import { getAssetUrl } from '@lighthouse/assets'
import { nanoid } from '@lighthouse/tools'

import type { Template, TemplateList } from './types'

export const blankTemplateWebsiteId = 'blankWebsite'

const blankTemplateWebsite: Template = {
    id: blankTemplateWebsiteId,
    name: '网页应用',
    icon: '',
    describe: 'PC端和H5端',
    describeText: null,
    primaryImage: getAssetUrl('common', 'BlankCreate.svg'),
    createdBy: '',
    createdTime: '',
    describeImageList: [],
    isBlankTemplate: true,
    iconColor: 'var(--color-gray-400)',
    iconBackgroundColor: 'var(--color-gray-100)',
    appId: ''
}
export const blankTemplateWxAppletId = 'blankWxApplet'

const blankTemplateWxApplet: Template = {
    id: blankTemplateWxAppletId,
    name: '创建小程序',
    icon: '',
    describe: '一键发布为微信小程序',
    describeText: null,
    primaryImage: getAssetUrl('common', 'CreatMiniProgram.svg'),
    createdBy: '',
    createdTime: '',
    describeImageList: [],
    isBlankTemplate: true,
    isNoDispark: false,
    iconColor: 'var(--color-black)',
    iconBackgroundColor: 'var(--color-gray-100)',
    appId: ''
}

// export const blankTemplate: TemplateList = [
//     { categoryId: 'recommend', name: '推荐', list: [blankTemplateWebsite, blankTemplateWxApplet] }
// ]
export const blankTemplate: TemplateList = [{ categoryId: 'create', name: '创建', list: [blankTemplateWebsite, blankTemplateWxApplet] }]
